import { z } from 'zod';
import { Option } from '../../types/Option';

export type CableArrangementType = 'bunched' | 'wall' | 'ceiling' | 'single-layer';

const options = [
    { value: 'bunched', label: 'Bunched' },
    { value: 'wall', label: 'Single Layer on Wall' },
    { value: 'ceiling', label: 'Single Layer on Ceiling' },
    { value: 'single-layer', label: 'Single Layer' },
] as Option<CableArrangementType>[];

const validator = z.enum(['bunched', 'wall', 'ceiling', 'single-layer']);

export const CableArrangement = {
    validator,
    options,
};
